import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { CleApiService } from 'src/app/services/cle-api-service';
import { CleApiEntite } from 'src/app/entites/cle-api';

@Component({
    templateUrl: './detail-cle-api.component.html',
    providers: [MessageService]
})
export class DetailCleApiComponent implements OnInit {

    cle: Partial<CleApiEntite>;
    modeEdition: boolean = false;
    submitted: boolean = false;
    chargementEnCours: boolean = false;
    today: Date = new Date();
    isMobile: boolean = false;
    
    // Pour afficher la clé générée
    cleGeneree: string = '';
    afficherCleGeneree: boolean = false;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private cleApiService: CleApiService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.isMobile = window.innerWidth < 768;
        if (this.config.data?.cle) {
            this.cle = { ...this.config.data.cle };
            // Convertir la date pour p-calendar
            if (this.cle.dateExpiration) {
                this.cle.dateExpiration = new Date(this.cle.dateExpiration);
            }
            this.modeEdition = true;
        } else {
            this.cle = {
                nom: '',
                taches: []
            };
            this.modeEdition = false;
        }
    }

    /**
     * Sauvegarde la clé (création ou modification)
     */
    sauvegarder() {
        this.submitted = true;

        if (!this.cle.nom || this.cle.nom.trim() === '') {
            return;
        }

        this.chargementEnCours = true;

        if (this.modeEdition) {
            this.cleApiService.modifierCleApi(this.cle.cleApiId, this.cle).subscribe({
                next: () => {
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Clé API modifiée avec succès' });
                    this.ref.close(true);
                },
                error: () => this.chargementEnCours = false
            });
        } else {
            this.cleApiService.creerCleApi(this.cle).subscribe({
                next: (cleCreee) => {
                    this.cleGeneree = cleCreee.valeurDechiffree;
                    this.cle.clientId = cleCreee.clientId;
                    this.afficherCleGeneree = true;
                    this.chargementEnCours = false;
                },
                error: () => this.chargementEnCours = false
            });
        }
    }

    /**
     * Ferme le dialogue après avoir confirmé la note de la clé
     */
    fermerApresCreation() {
        this.ref.close(true);
    }

    /**
     * Copie la clé générée dans le presse-papier
     */
    copierCle() {
        navigator.clipboard.writeText(this.cleGeneree);
        this.messageService.add({ severity: 'info', summary: 'Copié', detail: 'Clé API copiée dans le presse-papier' });
    }

    /**
     * Copie le Client ID dans le presse-papier
     */
    copierClientId() {
        navigator.clipboard.writeText(this.cle.clientId);
        this.messageService.add({ severity: 'info', summary: 'Copié', detail: 'Client ID copié dans le presse-papier' });
    }

    /**
     * Annule l'opération
     */
    annuler() {
        this.ref.close(false);
    }
}

